import { Col, Row, Button } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/login.scss";
import GalaxyLogo from "../assets/images/galaxy.svg";
import LoginAIImage from "../assets/images/icons/Login_AI_animation.gif";
import { Auth } from "../libs/utilities/helpers/Auth";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleMicrosoftLogin = () => {
    setLoading(true);

    const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
    const tenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID;
    const redirectUri = process.env.REACT_APP_BASE_URL;

    const scope = `openid profile email offline_access User.Read api://${clientId}/access_user`;

    const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&scope=${scope}`;

    setTimeout(() => {
      window.location.href = authUrl;
    }, 200);
  };

  useEffect(() => {
    if (Auth.isLoggedIn()) {
      navigate("/");
    } else {
      Auth.deregister();
    }
  }, [navigate]);

  return (
    <div className="login-page">
      <div className="login-wrapper">
        <Row className="login-container">

          {/* LEFT SIDE */}
          <Col xs={24} lg={12} className="login-left">
            <img src={GalaxyLogo} alt="Galaxy" className="logo" />

            <h1 className="title">Welcome to Galaxy</h1>

            {/* <p className="tagline">
              Your intelligent enterprise workspace powered by AI.
            </p> */}

            <Button
              size="large"
              className="login-btn"
              loading={loading}
              onClick={handleMicrosoftLogin}
            >
              Sign in with Microsoft
            </Button>
          </Col>

          {/* RIGHT SIDE */}
          <Col xs={0} lg={12} className="login-right">

            <img
              src={LoginAIImage}
              alt="Galaxy AI"
              className="ai-animation"
            />

            <div className="feature-description">
              <h3>Galaxy AI Capabilities</h3>

              <ul>
                <li>
                  Automatically summarize calls, emails, chats, and customer
                  conversations into clear actionable insights.
                </li>

                <li>
                  Analyze enterprise reports and financial data to highlight
                  key trends and performance indicators instantly.
                </li>

                <li>
                  Chat with your documents securely using enterprise-grade
                  generative AI designed for productivity.
                </li>
              </ul>
            </div>

          </Col>

        </Row>
      </div>
    </div>
  );
};

export default Login;